import * as React from 'react'
import Box from '@mui/material/Box'

import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../../redux/actions/app'
import { helpGetUserLoginAccountWithEmail } from '../../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail'
import { createUserCognito } from '../../../../../app/services/eAuth/createUserBasseAccountEAuth'
import { getUserOrganizationByLoginAccountCorpEntities } from '../../../../../app/services/Organization/getUserOrganizationByLoginAccountCorpEntities'
import { logEvent } from '../../../../../utils/LogEvents'
import { addUserOrganizationCorpEntities } from '../../../../../app/services/Organization/helpAddUserOfOrganization'
import { createInviteOrgStaffUser } from '../../../../../app/services/Invite/createOrgStaffRegistrationUserInvite'
import { helpGetUserOfSuscriber } from '../../../../../app/services/Suscriber/helpGetUsersOfSuscriber'
import { assignUserSubscriberCorpEntity } from '../../../../../app/services/Suscriber/assignUserSubscriberCorpEntity'
// eslint-disable-next-line
import jwt_decode from "jwt-decode";
import { namesTypesTraduc } from '../../../../../utils/traducTypes'
import useStylesAddUserForSuscriber from './Styles/useStylesAddUserForSuscriber'

import { useParams } from 'react-router-dom'
import { getEmailUserLogged } from '../../../../../utils/UserTools'
import { createUser } from '../../../../../app/services/LoginAccount/CreateUser'
import { useEffect, useState } from 'react'
import {
  getOrganizationWithID,
  getTypesUser
} from '../../../../../redux/actions/Organizations'

export default function StepperAddUserSuscriber ({
  setStateUserOrganization,
  item,
  setLoading
}) {
  const dispatch = useDispatch()
  const { id } = useParams()

  const classes = useStylesAddUserForSuscriber()
  const [organization, setorganization] = useState(null)

  // hooks new user values
  const [email, setemail] = useState('')
  const [firstName, setfirstName] = useState('')
  const [lastname, setlastName] = useState('')
  const [mobile, setmobile] = useState('')
  const [type, settype] = useState('')
  const [types, settypes] = useState([])

  // hooks contain error text
  const [errorEmail, changeErrorEmail] = useState(false)
  const [errorName, changeErrorName] = useState(false)
  const [errorlastName, changeErrorLastName] = useState(false)
  const [errorMobile, changeErrormobile] = useState(false)
  const [errorType, changeErrorType] = useState(false)
  // text error warning
  const [errorText, setErrorText] = useState('')

  const validateEmail = (email) => {
    const regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
    return regex.test(email)
  }

  // get types user and org
  useEffect(async () => {
    await getTypesUsers()
    await getOrganization()
  }, [])

  // get types of user request
  const getTypesUsers = async () => {
    const types = await dispatch(getTypesUser())
    settypes(types)
  }

  // get organization with ID
  const getOrganization = async () => {
    const response = await dispatch(getOrganizationWithID(id))
    setorganization(response)
  }
  // filter types not derived
  const typesfilter = types.filter((t) => t.organizationUserTypeId !== 2)

  // traduc types in spanish
  const traducSpanishTypes = (type) => {
    const nameTraduc = namesTypesTraduc.filter((item) => item.code === type)
    return nameTraduc && nameTraduc.length > 0 ? nameTraduc[0].name : ''
  }
  const handleEmailChange = (event) => {
    setemail(event.target.value)
    clearErrors()
  }
  const handlefirstNameChange = (event) => {
    setfirstName(event.target.value)
    clearErrors()
  }
  const handlelastNameChange = (event) => {
    setlastName(event.target.value)
    clearErrors()
  }
  const handleMobileChange = (event) => {
    setmobile(event.target.value)
    clearErrors()
    const number = isNaN(event.target.value)
    if (number || event.target.value < 0) {
      setErrorText('Ingrese un telefono valido')
      changeErrormobile(true)
    }
  }

  const handleChangeType = async (event) => {
    settype(event.target.value)
    clearErrors()
  }

  // set hooks error false
  const clearErrors = () => {
    changeErrorEmail(false)
    changeErrorName(false)
    changeErrorLastName(false)
    changeErrormobile(false)
    changeErrorType(false)
  }

  // verify if inputs completed
  const isAttributesCompleted = () => {
    setErrorText('Este campo es requerido')
    if (!validateEmail(email) || email === '') {
      if (!validateEmail(email)) {
        setErrorText('El email ingresado no es valido')
      }
      changeErrorEmail(true)
      changeErrorName(false)
      changeErrorLastName(false)
      changeErrormobile(false)
      changeErrorType(false)
      return false
    }
    if (firstName === '') {
      changeErrorEmail(false)
      changeErrorName(true)
      changeErrorLastName(false)
      changeErrormobile(false)
      changeErrorType(false)
      return false
    }
    if (lastname === '') {
      changeErrorEmail(false)
      changeErrorName(false)
      changeErrorLastName(true)
      changeErrormobile(false)
      changeErrorType(false)
      return false
    }
    if (type === '') {
      changeErrorEmail(false)
      changeErrorName(false)
      changeErrorLastName(false)
      changeErrormobile(false)
      changeErrorType(true)
      return false
    }
    if (errorMobile) {
      return false
    }
    return true
  }
  // create user for create
  const getUser = (idCognito) => {
    return {
      accountExternalRefId: idCognito,
      email: email,
      firstName: firstName,
      lastName: lastname,
      modificationUser: firstName + '.' + lastname,
      accountStatusCode: 'WAITING_VALIDATION',
      loginAccountPhone: {
        phoneNumber: mobile,
        phoneNumberTypeCode: 'MOBILE'
      }
    }
  }

  // filter is user in response is ACTIVE or WAITING_VALIDATION
  const filterUserActiveOrWaitingValidation = (response) => {
    return response.filter(
      (item) => item.user_status_id === 1 || item.user_status_id === 5
    )
  }

  // verify if user exists in other organization
  const verifyExistsUserInOrg = (data) => {
    const orgs = data.filter(
      (item) =>
        item.status.userStatusCode === 'ACTIVE' ||
        item.status.userStatusCode === 'WAITING_VALIDATION'
    )
    return orgs.filter((item) => item.organizationId !== id).length > 0
  }

  // verify if user exists in organization selected
  const userExistInOrgReply = (data) => {
    return data.filter((item) => item.organizationId === id)
  }

  // alert error
  const handleSetError = (text) => {
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar(text))
    // error
    setLoading(false)
  }

  // add user in suscriber and finish process
  const addUserInSuscriber = async (newuser, myuuid) => {
    // verify user not includes in suscriber
    try {
      const userSuscribers = await helpGetUserOfSuscriber(
        item.subscriber_ref_id
      )
      const { data } = userSuscribers
      // if user not include in suscriber
      if (data.filter((item) => item.user_id === newuser.userId).length === 0) {
        // get email user from TOKEN

        const asingSuscriber = {
          user_id: newuser.userId,
          subscriber_id: item.subscriber_id,
          creation_user: getEmailUserLogged(),
          creation_date: new Date()
        }

        try {
          // assing user in suscriber
          const assingSuscriberRequest = await assignUserSubscriberCorpEntity(
            asingSuscriber
          )
          await logEvent(
            'CGI - assignUserSubscriberCorpEntity',
            {
              body: asingSuscriber,
              response: assingSuscriberRequest
            },
            myuuid
          )
        } catch (error) {
          await logEvent(
            'CGI - assignUserSubscriberCorpEntity',
            {
              body: asingSuscriber,
              error: error
            },
            myuuid
          )
          handleSetError('Ocurrió un error. Intente nuevamente')
          setStateUserOrganization(false)
          return
        }
      }
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Usuario agregado con éxito.'))

      setStateUserOrganization(false)
    } catch (error) {
      handleSetError('Ocurrió un error. Intente nuevamente')
      setStateUserOrganization(false)
    }
  }

  // Send invite user and add user in suscriber
  const sendInviteAndAddUserinSuscriber = async (newuser, myuuid) => {
    // verify states
    if (
      newuser.loginAccountState === 'ACTIVE' &&
      newuser.userOrganizationState === 'ACTIVE'
    ) {
      handleSetError('Usuario ya existente y activo')
      return
    }
    if (
      newuser.loginAccountState === 'WAITING_VALIDATION' &&
      newuser.userOrganizationState === 'ACTIVE'
    ) {
      handleSetError(
        'Usuario ya activo pero cuenta de mail en login account pendiente'
      )

      return
    }
    if (
      newuser.loginAccountState === 'inexistente' ||
      (newuser.loginAccountState === 'WAITING_VALIDATION' &&
        (newuser.userOrganizationState === 'inexistente' ||
          newuser.userOrganizationState === 'WAITING_VALIDATION'))
    ) {
      // create new invite of send
      const newInvite = {
        inviteDate: new Date(),
        accountEmail: email,
        userId: newuser.userId,
        firstName: firstName,
        lastName: lastname,
        organizationName: organization.organizationName,
        organizationCuit: organization.organizationCuit,
        subscriberRefId: item.subscriber_ref_id
      }
      try {
        // invite user in org
        const sendCreateInvite = await createInviteOrgStaffUser(newInvite)
        await logEvent(
          'CGI - createOrgStaffRegistrationUserInvite',
          { invite: newInvite, response: sendCreateInvite },
          myuuid
        )
      } catch (error) {
        await logEvent(
          'CGI - createOrgStaffRegistrationUserInvite',
          {
            body: newInvite,
            error: error
          },
          myuuid
        )
        handleSetError('Ocurrió un error. Intente nuevamente')
        setStateUserOrganization(false)
        return
      }
    }
    // add user in suscriber
    await addUserInSuscriber(newuser, myuuid)
  }

  // Add user in organization and send invite and add user in suscriber
  const addUserProcess = async (newuser, myuuid) => {
    try {
      // verify not user of org
      const getUserOrganization =
        await getUserOrganizationByLoginAccountCorpEntities(
          newuser.loginAccountId
        )
      const orgWithReplyOrgId = userExistInOrgReply(
        getUserOrganization.data.data
      )
      if (orgWithReplyOrgId.length > 0) {
        // if exist user in selected org save userId and state
        const [org] = orgWithReplyOrgId
        newuser.userOrganizationState = org.status.userStatusCode
        newuser.userId = org.userId
      } else {
        // if not exist create User in org and save userId
        const userOrganization = {
          loginAccountId: newuser.loginAccountId,
          organizationId: id,
          organizationUserTypeCode: type,
          organizationCommercialUserTypeCode: 'SUBSCRIBER',
          userStatusCode: 'WAITING_VALIDATION'
        }
        try {
          // add user in organization
          const addUserOrganization = await addUserOrganizationCorpEntities(
            userOrganization
          )

          await logEvent(
            'CGI - addUserOrganizationCorpEntities',
            {
              userOrganization: userOrganization,
              response: addUserOrganization
            },
            myuuid
          )
          // save id and state
          newuser.userId = addUserOrganization.data?.data?.userId
          newuser.userOrganizationState = 'inexistente'
        } catch (error) {
          await logEvent(
            'CGI - addUserOrganizationCorpEntities',
            {
              userOrganization: userOrganization,
              error: error
            },
            myuuid
          )
          handleSetError('Ocurrió un error. Intente nuevamente')
          setStateUserOrganization(false)
          return
        }
      }
      // send invite and add suscriber
      await sendInviteAndAddUserinSuscriber(newuser, myuuid)
    } catch (error) {
      handleSetError('Ocurrió un error. Intente nuevamente')
      setStateUserOrganization(false)
    }
  }
  // createUser process --------------------------
  const handleCreateUserProcess = async (users, myuuid) => {
    // verify no suscriber max user count < of users length
    if (
      filterUserActiveOrWaitingValidation(users).length <
        item.subscriber_max_user_count ||
      !item.subscriber_max_user_count
    ) {
      const newuser = {
        loginAccountId: '',
        userId: '',
        idCognito: '',
        loginAccountState: '',
        userOrganizationState: ''
      }

      try {
        // get user and verify if exist user with email
        const user = await helpGetUserLoginAccountWithEmail(email)
        try {
          // get information of user
          const getUserOrganization =
            await getUserOrganizationByLoginAccountCorpEntities(
              user.data.loginAccount.loginAccountId
            )
          // if exist save id and state
          newuser.loginAccountId = user.data.loginAccount.loginAccountId
          newuser.loginAccountState =
            user.data.loginAccount.accountStatus.accountStatusCode

          // verify if user no include in one organization
          const userdata = getUserOrganization.data.data
          if (verifyExistsUserInOrg(userdata)) {
            handleSetError(
              'El email que se quiere dar de alta ya existe para otra organización'
            )
            return
          } else {
            // 5.2 consultar de donde se ve si es otro suscriptor al que esta agregado
          }
        } catch (error) {
          handleSetError('Ocurrió un error. Intente nuevamente')
          setStateUserOrganization(false)
          return
        }
      } catch (error) {
        // si no existe crearlos
        if (error.response?.statusText === 'Not Found') {
          newuser.loginAccountState = 'inexistente'
          try {
            // create user in cognito
            const createuserCognitoResponse = await createUserCognito(email)
            // log event
            await logEvent(
              'CGI - createUserBaseAccountEAuth',
              { email: email, response: createuserCognitoResponse },
              myuuid
            )
            const idCognito = { idCognito: null }
            if (createuserCognitoResponse.data?.cognitoUser?.User?.Username) {
              idCognito.idCognito =
                createuserCognitoResponse.data?.cognitoUser?.User?.Username
            } else if (createuserCognitoResponse.data?.cognitoUser?.idCognito) {
              idCognito.idCognito =
                createuserCognitoResponse.data?.cognitoUser?.idCognito
            }
            // get new user of create login account
            const user = getUser(idCognito.idCognito)
            try {
              // crear usuario loggin account
              const createUserAccount = await createUser(user)

              await logEvent(
                'CGI - loginAccountCreate',
                { user: user, response: createUserAccount },
                myuuid
              )
              // save login accoutn id
              newuser.loginAccountId =
                createUserAccount.data?.data?.loginAccountId
            } catch (error) {
              await logEvent(
                'CGI - loginAccountCreate',
                { user: user, error: error },
                myuuid
              )
              handleSetError('Ocurrió un error. Intente nuevamente')
              setStateUserOrganization(false)
              return
            }
          } catch (error) {
            await logEvent(
              'CGI - createUserBaseAccountEAuth',
              { body: email, response: error },
              myuuid
            )
            handleSetError('Ocurrió un error. Intente nuevamente')
            setStateUserOrganization(false)
            return
          }
        } else {
          handleSetError('Ocurrió un error. Intente nuevamente')
          setStateUserOrganization(false)
          return
        }
      }
      // add in org, send invitation and add insuscriber
      await addUserProcess(newuser, myuuid)
    } else {
      handleSetError(
        'El suscriptor posee la cantidad máxima de usuarios establecida'
      )
      setStateUserOrganization(false)
    }
  }

  // create user submit
  const handleCreateUserSubmit = async (body) => {
    setLoading(true)
    if (isAttributesCompleted()) {
      try {
        // new uuid
        const myuuid = uuidv4()
        // get list users of suscriber
        const response = await helpGetUserOfSuscriber(item.subscriber_ref_id)
        const users = response.data
        // play process create user, send users of suscriber and uuid of await logEvent
        await handleCreateUserProcess(users, myuuid)
      } catch (error) {
        handleSetError('Ocurrió un error. Intente nuevamente')
        setStateUserOrganization(false)
      }
    }
    setLoading(false)
  }

  return (
    <Box className={classes.mainBox}>
      <Box>
        <Box className={classes.box1}>
          <Typography className={classes.typographyAddUser}>
            Añadir un usuario al suscriptor
          </Typography>
          <Typography className={classes.typographyInstructions}>
            Complete los siguientes datos del nuevo colaborador que desea añadir
            al suscriptor:
          </Typography>

          <Typography className={classes.typographyFields}>
            Correo electrónico
          </Typography>

          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            required
            value={email}
            onChange={handleEmailChange}
            style={{ width: '70%' }}
            error={errorEmail}
            helperText={errorEmail ? errorText : null}
          />

          <Typography className={classes.typographyFields}>Nombre</Typography>

          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            value={firstName}
            onChange={handlefirstNameChange}
            error={errorName}
            helperText={errorName ? errorText : null}
            style={{ width: '70%' }}
          />

          <Typography className={classes.typographyFields}>Apellido</Typography>
          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            value={lastname}
            onChange={handlelastNameChange}
            error={errorlastName}
            helperText={errorlastName ? errorText : null}
            style={{ width: '70%' }}
          />
          <Typography className={classes.typographyFields}>Telefono</Typography>

          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            value={mobile}
            onChange={handleMobileChange}
            error={errorMobile}
            helperText={errorMobile ? errorText : null}
            style={{ width: '70%' }}
          />
          <Typography className={classes.typographyFields}>
            Permisos del colaborador
          </Typography>
          <FormControl
            variant="standard"
            error={errorType}
            sx={{ width: '70%' }}
          >
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              value={type}
              onChange={handleChangeType}
              size="small"
            >
              {types.length > 0
                ? (
                    typesfilter.map((t) => (
                  <MenuItem
                    key={t.organizationUserTypeCode}
                    value={t.organizationUserTypeCode}
                  >
                    {traducSpanishTypes(t.organizationUserTypeCode)}
                  </MenuItem>
                    ))
                  )
                : (
                <MenuItem value="">
                  No se encontraron tipos de usuarios
                </MenuItem>
                  )}
            </Select>
            <FormHelperText>{errorType ? errorText : null}</FormHelperText>
          </FormControl>
        </Box>
      </Box>
      <Box className={classes.buttons}>
        <Box
          className={classes.createButton}
          sx={{
            display: 'flex',
            '&:hover': {
              bgcolor: '#1BF57F'
            }
          }}
        >
          <Typography
            onClick={() => {
              const user = getUser()
              handleCreateUserSubmit(user)
            }}
            className={classes.typographyCreateButton}
          >
            Crear
          </Typography>
        </Box>
        <ButtonCancel setStateUserOrganization={setStateUserOrganization} />
      </Box>
    </Box>
  )
}

function ButtonCancel ({ setStateUserOrganization }) {
  const classes = useStylesAddUserForSuscriber()
  return (
    <Box className={classes.cancelButton}>
      <Typography
        onClick={() => {
          setStateUserOrganization(false)
        }}
        className={classes.typographyCancelButton}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
